import { SwipeableDrawer, Box, useTheme } from '@mui/material';

/**
 * v4 mobile bottom sheet (#1377 board): the mobile-only overlay for quick-add
 * and pickers (V4_ADDENDUM convention 4). Overlay surface with 16px top
 * corners, a top hairline, a 36x4 grab handle, and an optional title row.
 * Backdrop dims the base screen. Desktop keeps inline forms - never render
 * this above the sm breakpoint.
 *
 * #1425: SwipeableDrawer so a downward drag on the sheet dismisses it
 * without saving (backdrop tap and Escape still close via onClose). Sheets
 * only ever open from an explicit button, so onOpen is a required no-op and
 * the edge-swipe-to-open affordance is disabled.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {function} props.onClose
 * @param {React.ReactNode} [props.title]  15px medium title row under the handle
 * @param {React.ReactNode} props.children
 * @param {object} [props.sx]  extra sx merged onto the sheet paper
 */
const Sheet = ({ open, onClose, title, children, sx }) => {
  const theme = useTheme();
  const { ds, palette } = theme;

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      disableDiscovery
      PaperProps={{
        sx: {
          backgroundColor: palette.surface.overlay,
          backgroundImage: 'none',
          borderTop: `1px solid ${palette.overlay.border}`,
          borderRadius: `${ds.radius.sheet}px ${ds.radius.sheet}px 0 0`,
          boxShadow: `0 -8px 32px color-mix(in srgb, ${palette.surface.page} 70%, transparent)`,
          padding: '10px 20px 20px',
          ...sx,
        },
      }}
    >
      <Box
        aria-hidden
        sx={{
          width: 36,
          height: 4,
          borderRadius: '2px',
          backgroundColor: palette.borderStrong,
          margin: '0 auto 12px',
          flexShrink: 0,
        }}
      />
      {title != null && (
        <Box
          sx={{
            fontSize: '15px',
            fontWeight: ds.font.weightMedium,
            color: palette.text.primary,
            paddingBottom: '8px',
            borderBottom: `1px solid ${palette.divider}`,
            marginBottom: '12px',
          }}
        >
          {title}
        </Box>
      )}
      {children}
    </SwipeableDrawer>
  );
};

export default Sheet;
